import { useEffect, useState } from 'react';
import { PrismicRichText } from 'prismic/types/richtext';
import { FrontpageHero, Maybe, PageHero } from 'prismic-types';

import { ArticleSection } from 'components/article-section/ArticleSection';
import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';
import { H1 } from 'components/heading/Heading';
import { asText } from 'components/rich-text/RichText';
import { HeroCarouselContainer } from 'containers/slices/HeroCarouselContainer';

type Props = {
  title?: PrismicRichText;
  seo_title?: PrismicRichText;
  hero?: Array<PageHero | FrontpageHero>;
  render_as_new_hero?: boolean;
  currentUid?: Maybe<string> | undefined;
  randomized_hero?: boolean;
};

export const PageContainer = ({
  title,
  seo_title,
  hero = [],
  randomized_hero = false,
  currentUid = '',
}: Props) => {
  const [randomIndex, setRandomIndex] = useState<number>(0);
  const [isReady, setIsReady] = useState(!randomized_hero);

  const renderHero =
    (hero?.filter((item) => item.title || item.image) ?? []).length > 0;

  useEffect(() => {
    setRandomIndex(Math.floor(Math.random() * hero.length));
    setIsReady(true);
  }, [hero]);

  return (
    <>
      {!renderHero && asText(title) && (
        <ArticleSection>
          <GridLayout>
            <GridLayoutItem
              columns={{ tablet: 7, desktop: 8 }}
              offset={{ desktop: 2 }}
            >
              <H1>{asText(title ?? seo_title)}</H1>
            </GridLayoutItem>
          </GridLayout>
        </ArticleSection>
      )}

      {renderHero && (
        <div>
          <HeroCarouselContainer
            data={randomized_hero ? [hero[randomIndex]] : hero}
            currentUid={currentUid}
            isReady={isReady}
          />
        </div>
      )}
    </>
  );
};
